// The site's absolute origin, the one place its default lives. Builds set
// SITE_URL (production, previews); everything else is production. Read through
// `resolveSiteUrl` by vite.config.ts (which defines `import.meta.env.SITE_URL`
// from the environment), src/lib/site/seo.ts (the app) and
// scripts/postbuild-seo.ts (sitemap and robots.txt).
export const DEFAULT_SITE_URL = 'https://www.directactioneverywhere.com'

/** `value` (the SITE_URL setting) or the production origin, without a trailing slash. */
export const resolveSiteUrl = (value: string | undefined) =>
  (value || DEFAULT_SITE_URL).replace(/\/+$/, '')
